import appStore from 'store';
import api from './utils';

const store = {

    namespaced: true,

    state: {
        hedgeAccountEnum:[],
        ExternalOrderStatusEnum:[
            {key:'NEW', label:'刚刚创建'},
            {key:'PARTIALLY_FILLED', label:'部分成交'},
            {key:'FILLED', label:'已经成交完成'},
            {key:'CANCELED', label:'已取消'},
            {key:'CREATE_FAILED', label:'创建失败'},
        ],
        HedgeSourceRecordStatusEnum:[
            {key:'GIVEUP_NO_STRATEGY', label:'未匹配对冲策略，不进行对冲'},
            {key:'GIVEUP_USERID', label:'未开启对冲或者不满足条件,或者标记为不需要对冲'},
            {key:'GIVEUP_AMT', label:'未达到配置最小对冲余额，不进行对冲'},
            {key:'NOT_HEDGED', label:'未对冲，等待对冲，这些会被定期合并对冲'},
            {key:'TRIED_HEDGED_NOT_CONFIRMED', label:'已发起合并对冲(没有确认)'},
            {key:'AUTO_HEDGED_SUCC', label:'已经对冲成功'},
            {key:'HEDGE_TRIED_FAIL_CAN_RETRY', label:'已经发起对冲并且确认对冲失败，一般出现在比方余额不足，参数错误等等情况可以进行重试'},
            {key:'HEDGE_TRIED_FAIL_CANNOT_RETRY', label:'已经发起对冲,针对其他系统异常返回无法确定状态等这种就无法进行重试'},
            {key:'HEDGED_CANCELED_CANNOT_RETRY', label:'已经发起对冲，但是委托未完成又被取消了'},
            {key:'MANUAL_HEDGED_SUCC', label:'已经手动对冲成功'},
        ],
        RiskHedgeFailTypeEnum:[
            {key:'INSUFFICIENT_BALANCE', label:'余额不足'},
            {key:'PARAM_ERROR', label:'参数错误'},
            {key:'UNKNOWN', label:'未知原因'},
            {key:'GIVEUP', label:'金额太小放弃'},
            {key:'CREATE_TRIED_NOT_EXISTS_AFTER_FAIL', label:'创建失败，后续查询确认不存在'},
        ],
        TryHedgeResultEnum:[
            {key:'STRTEGY_NOT_EXIST', label:'不存在对应的策略'},
            {key:'STRTEGY_EXIST_BUT_NOT_OPEN', label:'策略存在，但是关闭状态中'},
            {key:'STRTEGY_EXIST_BUT_PENDING_HEDGE_EXISTS', label:'存在对冲策略但是同时存在PENDING的对冲，不能再次发起对冲'},
            {key:'STRTEGY_EXISTS_NOT_HIT_CONDITION', label:'策略存在但是没有达到阈值条件'},
            {key:'STRTEGY_EXISTS_HEDGE_STARTED', label:'策略存在并且已经尝试过发起对冲'},
            {key:'STRATEGY_SHOULD_NOT_DUPLICATE_HEDGE', label:'已经存在对应的原始记录，不重复对冲'},
        ],
        hedgeProductTypeOptions:[{key:'SPOT', label:'现货'}, {key:'SUPER_CONTRACT', label:'超级合约'}],
        pickerOptions: {shortcuts: [
            {text: '最近一天', onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24);picker.$emit('pick', [start, end]);}},
            {text: '最近三天', onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*3);picker.$emit('pick', [start, end]);}},
            {text: '最近一周', onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*7);picker.$emit('pick', [start, end]);}},
            {text: '最近一个月', onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*30);picker.$emit('pick', [start, end]);}},
            {text: '最近两个月', onClick(picker) {const end = new Date();const start = new Date();start.setTime(start.getTime() - 3600*1000*24*60);picker.$emit('pick', [start, end]);}}
        ]}
    },

    mutations: {
        setHedgeAccountEnumCache(state, payload) {
            state.hedgeAccountEnum = payload;
        },
    },

    actions: {
        getHedgeAccountEnum(context) {
            api.queryExchangeAccountEnum().then((response)=>{
                let payload = response.data
                context.commit('setHedgeAccountEnumCache', payload)
            });
        }
    }
}

appStore.registerModule('newHedgeStore', store)
